export default __webpack_public_path__ + "static/media/BP2JPGR-min.ae4370bd.jpeg";